/* src/app/pages/ui-kit/components/select-button-view/select-button-view.component.scss */
.box {
  padding: 1rem;
  border: 1px solid 16px;
  border-radius: 8px;
  margin-bottom: 1rem;
  background: var(--contrast-inverse);
}
/*# sourceMappingURL=select-button-view.component.css.map */
